export const GET_WORKSPACE_QUERY = `
    query Workspace($workspace_id: Int!) {
        workspace(workspace_id: $workspace_id) {
            id
            name
            image
            thumb
            archived
            custom_properties {
                key
                value
            }
            account {
                id
                name
                type
            }
        }
    }
 
`;

export const GET_WORKSPACES_QUERY = `
    query Workspaces($account_id: Int, $trashed: Boolean, $filter: [CustomPropertyInput], $archived: Boolean, $admin: Boolean) {
        workspaces(account_id: $account_id, trashed: $trashed, filter: $filter, archived: $archived, admin: $admin) {
            id
            name
            image
            thumb
            archived
            custom_properties {
                key
                value
            }
            account {
                id
                name
                type
            }
        }
        workspaceProperties(account_id: $account_id, filter: $filter, trashed: $trashed) {
            key
            value
        }
    }
 
`;

export const GET_WORKSPACE_USERS_QUERY = `
    query WorkspaceUsers($workspace_id: Int, $page: Int, $limit: Int) {
        workspaceUsers(workspace_id: $workspace_id, $page: $page, $limit: $limit) {
            id
            user_name
            role
            role_id
        }
    }
`;

export const GET_WORKSPACE_TEAM_MEMBERS_QUERY = `
    query TeamMembers($workspace_id: Int!, $role: RoleEnum, $page: Int, $limit: Int) {
        teamMembers(workspace_id: $workspace_id, role: $role, page: $page, limit: $limit) {
            user {
                id
                first_name
                last_name
                username
                email
                phone
                avatar
                verified
                last_login
            }
            projects {
                applies_to_all
                invited_date
                project {
                    id
                    name
                    due_date
                    creator_count
                    image
                }
                role {
                    id
                    name
                    seniority
                }
                invited_by {
                    id
                    first_name
                    last_name
                    username
                    email
                    phone
                    avatar
                }
                features {
                    invited_date
                    role {
                        id
                        name
                        seniority
                    }
                    invited_by {
                        id
                        first_name
                        last_name
                        username
                        email
                        phone
                        avatar
                    }
                }
            }
            role {
                id
                name
                seniority
            }
        }
    }
`;

export const GET_ACCOUNT_TEAM_MEMBERS_NO_PROJECT_QUERY = `
    query TeamMembers($account_id: Int!) {
        teamMembers(account_id: $account_id) {
            user {
                id
                first_name
                last_name
                username
                email
                phone
                avatar
                verified
                last_login
            }
            role {
                id
                name
                seniority
            }
        }
    }
`;

export const GET_WORKSPACE_TEAM_MEMBERS_NO_PROJECT_QUERY = `
    query TeamMembers($workspace_id: Int!, $role: RoleEnum) {
        teamMembers(workspace_id: $workspace_id, role: $role) {
            user {
                id
                first_name
                last_name
                username
                email
                phone
                avatar
                verified
                last_login
            }
            role {
                id
                name
                seniority
            }
        }
    }
`;